
export const NAVIGATION_RETAIL = [

  {
    name: 'Customer Consent Form',
    icon: '../../assets/svg/white/baseline_description_white_24dp.png',
    link: 'laas/consent-form',
    routerLinkActive:"active",
    isSelected: false
  },

  // {
  //   name: 'Land Verification',
  //   icon: '../../assets/svg/white/baseline_landscape_white_24dp.png',
  //   link: 'laas/bhoomi',
  //   isSelected: false
  // },

  {
    name: 'Land Verification (Fruits)',
    icon: '../../assets/svg/white/baseline_landscape_white_24dp.png',
    link: 'laas/land-records-ka',
    isSelected: false
  },

  {
    name: 'CIC Report',
    icon: '../../assets/svg/white/baseline_credit_card_white_24dp.png',
    submenu: [
      // { name: 'Customer Consent Form', link:'financial/cibil-consent'},
      { name: 'Credit Report', link: 'creditview',isSubMenuSelected:false },
      // { name: 'Generate CIBIL Report', link: 'creditgenerate' },

    ]
  },

  {
    name: 'Geo Mapping Report',
    icon: '../../assets/svg/white/baseline_business_white_24dp.png',
    link: 'laas/geo-mapping',
    isSelected: false
  },

  {
    name: 'BRE - Status',
    icon: '../../assets/svg/white/baseline_business_white_24dp.png',
    link: 'laas/bre-status',
    isSelected: false
  },

/*   {
    name: 'Validation Report',
    icon: '../../assets/svg/white/baseline_assignment_white_24dp.png',
    link: 'laas/esign/report'
  }, */
  {
    name: 'Loan Renewal Application',
    icon: '../../assets/svg/white/baseline_file_copy_white_24dp.png',
    // link: 'laas/loans/apply',
    link: 'laas/loan-renewal-form',
    isSelected: false
  },


];

export const NAVIGATION_RETAIL_MP = [

  {
    name: 'Customer Consent Form',
    icon: '../../assets/svg/white/baseline_description_white_24dp.png',
    link: 'laas/consent-form',
    routerLinkActive:"active",
    isSelected: false
  },

  {
    name: 'Land Verification',
    icon: '../../assets/svg/white/baseline_landscape_white_24dp.png',
    link: 'laas/land-records-mp',
    isSelected: false
  },

  {
    name: 'CIC Report',
    icon: '../../assets/svg/white/baseline_credit_card_white_24dp.png',
    submenu: [
      // { name: 'Customer Consent Form', link:'financial/cibil-consent'},
      { name: 'Credit Report', link: 'creditview',isSubMenuSelected:false },
      // { name: 'Generate CIBIL Report', link: 'creditgenerate' },

    ]
  },

  {
    name: 'Geo Mapping Report',
    icon: '../../assets/svg/white/baseline_business_white_24dp.png',
    link: 'laas/geo-mapping',
    isSelected: false
  },

  {
    name: 'BRE - Status',
    icon: '../../assets/svg/white/baseline_business_white_24dp.png',
    link: 'laas/bre-status',
    isSelected: false
  },

/*   {
    name: 'Validation Report',
    icon: '../../assets/svg/white/baseline_assignment_white_24dp.png',
    link: 'laas/esign/report'
  }, */
  {
    name: 'Loan Renewal Application',
    icon: '../../assets/svg/white/baseline_file_copy_white_24dp.png',
    // link: 'laas/loans/apply',
    link: 'laas/loan-renewal-form',
    isSelected: false
  },


];

export const NAVIGATION_RETAIL_CO = [
  // {
  //   name: 'Digilocker Documents',
  //   icon: '../../assets/svg/white/baseline_description_white_24dp.png',
  //   link: 'laas/digilocker'
  // },
  {
    name: 'Customer Consent Form',
    icon: '../../assets/svg/white/baseline_description_white_24dp.png',
    link: 'laas/consent-form',
    routerLinkActive:"active",
    isSelected: false
  },
  {
    name: 'Validation Report',
    icon: '../../assets/svg/white/baseline_assignment_white_24dp.png',
    link: 'laas/esign/report',
    isSelected: false
  },
  {
    name: 'BRE - Status',
    icon: '../../assets/svg/white/baseline_business_white_24dp.png',
    link: 'laas/bre-status',
    isSelected: false
  },
  {
    name: 'Loan Renewal Application',
    icon: '../../assets/svg/white/baseline_file_copy_white_24dp.png',
    // link: 'laas/loans/apply',
    link: 'laas/loan-renewal-form',
    isSelected: false
  }
];

export const NAVIGATION_RETAIL_AP = [

  {
    name: 'Customer Consent Form',
    icon: '../../assets/svg/white/baseline_description_white_24dp.png',
    link: 'laas/consent-form',
    routerLinkActive:"active",
    isSelected: false
  },

  {
    name: 'Land Verification',
    icon: '../../assets/svg/white/baseline_landscape_white_24dp.png',
    link: 'laas/land-records-ap',
    isSelected: false
  },

  {
    name: 'CIC Report',
    icon: '../../assets/svg/white/baseline_credit_card_white_24dp.png',
    submenu: [
      // { name: 'Customer Consent Form', link:'financial/cibil-consent'},
      { name: 'Credit Report', link: 'creditview',isSubMenuSelected:false },
      // { name: 'Generate CIBIL Report', link: 'creditgenerate' },

    ]
  },

  {
    name: 'Geo Mapping Report',
    icon: '../../assets/svg/white/baseline_business_white_24dp.png',
    link: 'laas/geo-mapping',
    isSelected: false
  },


  {
    name: 'BRE - Status',
    icon: '../../assets/svg/white/baseline_business_white_24dp.png',
    link: 'laas/bre-status',
    isSelected: false
  },

/*   {
    name: 'Validation Report',
    icon: '../../assets/svg/white/baseline_assignment_white_24dp.png',
    link: 'laas/esign/report'
  }, */
  {
    name: 'Loan Renewal Application',
    icon: '../../assets/svg/white/baseline_file_copy_white_24dp.png',
    // link: 'laas/loans/apply',
    link: 'laas/loan-renewal-form',
    isSelected: false
  },


];


export const SEND_TO_CBS_MENU = [

  {
    name: 'Loan Renewal Application',
    icon: '../../assets/svg/white/baseline_file_copy_white_24dp.png',
    // link: 'laas/loans/apply',
    link: 'laas/loan-renewal-form',
    isSelected: false
  }
];










